import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'
const url = store.getters.getPostUrl;
export default {
	add(param) {
		return request({
			url: store.getters.getPostUrl + 'organization',
			method: 'post',
			data: param
		})
	},
	edit(param) {
		return request({
			url: store.getters.getPostUrl + 'organization',
			method: 'put',
			data: param
		})
	},
	page(param) {
		return request({
			url: store.getters.getPostUrl + 'organization/page',
			method: 'post',
			data: param
		})
	},
	// get(param) {
	// 	return request({
	// 		url: store.getters.getPostUrl + 'organization',
	// 		method: 'get',
	// 		params: param
	// 	})
	// },
	getChildren(param) {
		return request({
			url: store.getters.getPostUrl + 'organization/children',
			method: 'get',
			params: param
		})
	},
	remove(param) {
		return request({
			url: store.getters.getPostUrl + 'organization',
			method: 'delete',
			params: param
		})
	},
	sort(param) {
		return request({
			url: store.getters.getPostUrl + 'organization/sort',
			method: 'put',
			params: param
		})
	},
	updateState(param) {
		return request({
			url: store.getters.getPostUrl + 'organization/updateState',
			method: 'put',
			params: param
		})
	},
	getParent(param) {
		return request({
			url: store.getters.getPostUrl + 'organization/getParent',
			method: 'get',
			params: param
		})
	},
  updateCheckAllOrNot(param) {
    return request({
      url: store.getters.getPostUrl + 'organization/updateCheckAllOrNot',
      method: 'put',
      params: param
    })
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/system/organizationTab.js